import NotAuthorized from './NotAuthorized';
import NotFound from './NotFound';
import ServerError from './ServerError';
import NoInternet from './NoInternet';

export default { NotFound, NotAuthorized, ServerError, NoInternet };
